export const VERSIONS = {
  V1: 'v1',
  V2: 'v2'
};

export const SERVICES = {
  DIGITIZATION: 'digitization',
  TERRAIN: 'terrain',
  HYDROLOGY: 'hydrology',
  ENVIRONMENT: 'environment',
  PEDOLOGY: 'pedology',
  SUB_PROJECT: 'sub_project/pedology',
  MANAGEMENT: 'management',
  TRACEABILITY: 'traceability',
  ENV: 'env'
};

export const RESOURCES = {
  CULTIVATION: 'cultivation',
  FARMER: 'farmer',
  FARM: 'farm',
  HARVEST: 'harvest',
  REPORT: 'report',
  SMS: 'sms',
  PROCUREMENT: 'procurement',
  RECEPTION: 'reception',
  AUTHENTICATION: 'auth',
  WEATHER: 'weather',
  DASHBOARD: 'dashboard',
  CROPINFECTION: 'crop_infection',
  DISEASE: 'disease',
  PEST: 'pest',
  FIELD_OFFICER: 'field_officer',
  LOCATION: 'location',
  EXPORT: 'export',
  MARKET_PRICE: 'marketprice',
  EVALUATE: 'evaluate',
  TEMPLATE: 'template',
  CATEGORY: 'category',
  FARMER_GROUP: 'farmer_group',
  CROP_CALENDAR: 'crop/calendar',
  CROP: 'crop',
  UTILITY: 'utility',
  CENTER: 'center',
  TRANSFER: 'transfer',
  PROCESS: 'process'
};

export const BASE_ENDPOINTS = {
  // Format with or without tenant ID
  createEndpoint: (service, version, resource = '', includeTenant = true) => {
    let base = '';

    // Check if service and version are provided
    if (service && version) {
      base = `/${service}/${version}`;
    }

    // If resource is provided, add it with or without tenant ID
    if (resource) {
      return includeTenant
        ? `${base}/:tenantId/${resource}`
        : `${base}/${resource}`;
    }

    // If no resource is provided, return only the base
    return base;
  }
};
